import React from "react";
import { SingleMovie } from "pages";

const SingleMovieRoute = () => {
  return (
    <>
      <SingleMovie />
    </>
  );
};

export default SingleMovieRoute;
